import React from 'react';
import "../../styles/global-hero.css";

const Hero = () => {
    return (
        <div className="global-hero">
            <div className="container text-center">
                <h1>RTI Act</h1>
                <p>Home &gt; RTI Act</p>
            </div>
        </div>
    )
}

export default Hero;